export default __webpack_public_path__ + "static/media/shoppinglist_female@2x.324e3410.png";